<template>
  <div>
    <div style="max-width: 1000px; margin: 48px auto">
      <h3 style="text-align: center">Regulamin sieci Domu Studenta PŚk</h3>
      <ol>
        <li>
          Należy bezwzględnie podporządkować się zrządzeniom administratorów
          sieci.
        </li>
        <li>Nie wolno wykorzystywać sieci do celów komercyjnych.</li>
        <li>Nie wolno rozpowszechniać nielegalnego oprogramowania.</li>
        <li>Osoba podłączona do sieci musi być mieszkańcem D.S. PŚk</li>
        <li>
          Należy przestrzegać następujących zasad związanych z funkcjonowaniem
          sieci lokalnej:
          <ul style="list-style-type: disc">
            <li>
              osoba dysponująca wadliwym sprzętem (np. kartą sieciową),
              wpływającą szkodliwie na pracę całej sieci jest zobowiązana do
              odpięcia wadliwego urządzenia od sieci lokalnej,
            </li>
            <li>
              podpinanie się do sieci może następować tylko i wyłącznie za zgodą
              administratorów sieci,
            </li>
            <li>
              wszelkie zmiany usytuowania komputera (zmiana pokoju, itp.), mogą
              odbywać się w porozumieniu z administratorami sieci,
            </li>
            <li>
              nie wolno używać swojego wejścia do sieci do celów niezgodnych z
              przeznaczeniem (eksperymentowanie),
            </li>
            <li>
              w przypadku korzystania z sieci Microsoft Windows obowiązuje
              następujący format identyfikacji komputera:
            </li>
            <ul style="list-style-type: circle">
              <li>nazwa komputera: dowolne, ale cenzuralne określenie,</li>
              <li>grupa robocza: Nazwa Twojego Akademika,</li>
              <li>
                opis komputera: musi zawierać: imię, nazwisko oraz numer pokoju
                użytkownika.
              </li>
            </ul>
            <li>
              inne protokoły niż TCP/IP są dozwolone tylko za zgodą
              administratora sieci lokalnej.
            </li>
          </ul>
        </li>
        <li>
          Osoba przyłączona do sieci ponosi pełną odpowiedzialność za:
          <ul style="list-style-type: disc">
            <li>
              wszelkie dane i programy znajdujące się w pamięci i/lub na dyskach
              komputera podłączonego do sieci;
            </li>
            <li>szkody wyrządzone innym użytkownikom;</li>
            <li>
              odcinek sieci znajdujący się w obrębie pokoju, w którym znajduje
              się podłączony komputer;
            </li>
          </ul>
        </li>
        <li>
          Prywatne strony (np. WWW, FTP, itp.) mogą być udostępnione tylko i
          wyłącznie za zgodą administracji sieci.
        </li>
        <li>
          Sieć jest plombowana i każda próba rozłączanie sieci wiąże się z
          natychmiastowym odłączeniem od sieci.
        </li>
        <li>
          Administrator ma prawo kontrolować wykorzystywane protokoły i stan
          plomb oraz wezwać użytkownika na rozmowę w przypadku działań
          niezgodnych z regulaminem.
        </li>
        <li>
          Każdego użytkownika komputera obowiązuje instalacja programu
          antywirusowego oraz firewalla.
        </li>
        <li>
          Administratorzy sieci nie są zobowiązani do konfiguracji systemów
          operacyjnych czy programów używanych przez osoby podłączone do sieci;
          udzielają jedynie informacji o parametrach niezbędnych do działania
          komputera w sieci.
        </li>
        <li>
          Niepoprawne skonfigurowanie używanego oprogramowania powodujące
          nieprawidłowe działanie sieci (np. ręczne wpisanie swojego numeru IP)
          może się wiążąc z czasowym odłączeniem od sieci osoby za to
          odpowiedzialnej.
        </li>
      </ol>
    </div>

    <a-row style="text-align: center">
      <a-form
          :form="form"
          :label-col="{ span: 16 }"
          :wrapper-col="{ span: 8 }"
          @submit="submit"
      >
        <a-form-item
            label="Zapoznałem(am) się z Regulaminem Sieci Domu Studenta PŚk i zobowiązuję się do jego przestrzegania"
            style="text-align: left"
        >
          <a-switch
              v-decorator="[
              'accepted',
              {
                valuePropName: 'checked',
                rules: [
                  {
                    required: true,
                    message: 'Musisz zaakceptować regulamin!',
                  },
                ],
              },
            ]"
              @change="changeSwitchTerms"
          />
        </a-form-item>
      </a-form>
    </a-row>

    <a-row style="text-align: center">
      <a-button style="margin-right: 24px" type="default" @click="back">
        <a-icon type="left"/>
        Wróć
      </a-button>
      <a-button :disabled="!checkedTerms" type="primary" @click="submit">
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkedTerms: false,
      formLayout: "horizontal",
      form: this.$form.createForm(this, {name: "coordinated"}),
    };
  },
  mounted() {
    // let data = this.$store.getters["getTermsData"];
    // this.form.setFieldsValue({
    //   accepted: data.accepted,
    // });
  },
  methods: {
    submit: function () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.$store.commit("updateTermsData", values);
          this.$emit("nextStep");
        }
      });
    },
    back: function () {
      this.$emit("prevStep");
    },
    changeSwitchTerms: function (status) {
      this.checkedTerms = status;
    },
  },
};
</script>
